import { render, staticRenderFns } from "./editHelp.vue?vue&type=template&id=50698b05&scoped=true&"
import script from "./editHelp.vue?vue&type=script&lang=js&"
export * from "./editHelp.vue?vue&type=script&lang=js&"
import style0 from "./editHelp.vue?vue&type=style&index=0&id=50698b05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50698b05",
  null
  
)

export default component.exports